//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectEdgeList.js";
import "../no/SelectBody.js";
import "../no/ScCollector.js";
import "../no/SelectBodyList.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectEdge.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AddonOperation",1,0],[0,"ApplyColor",1,0],[0,"AssignColor",1,0],[1,"AttachEdge",0,"SelectEdgeList",0],[1,"AttachScrap",0,"SelectBody",0],[1,"BoundaryList",0,"ScCollector",0],[1,"ChangeColScrap",0,"SelectBodyList",0],[1,"CopyDistance",0,"Expression",0],[0,"CopyFromPoint",1,"Point",0],[0,"CopyMethod",1,0],[0,"CopyToPoint",1,"Point",0],[0,"CopyVector",1,"Direction",0],[1,"CurveList",0,"Section",0],[0,"DefStationNum",1,0],[0,"DoubleA",1,0],[0,"DoubleAngle",1,0],[0,"DoubleB",1,0],[0,"DoubleH",1,0],[0,"DoubleR",1,0],[0,"DoubleRf",1,0],[0,"EditMethod",1,0],[0,"EditStationNum",1,0],[1,"ExistScrap",0,"SelectBodyList",0],[0,"HoleColor",1,0],[0,"IncludeOverlapOvercut",1,0],[0,"MinRad",1,0],[0,"MinimumRadius",1,0],[0,"OvercutColor",1,0],[1,"OvercutEdge",0,"SelectEdge",0],[0,"OvercutOperation",1,0],[0,"OverlapColor",1,0],[0,"OverlapWidth",1,0],[0,"PierceType",1,0],[0,"PiercingColor",1,0],[0,"PilotingColor",1,0],[0,"ProcessFive",1,0],[0,"ProcessFour",1,0],[0,"ProcessOne",1,0],[0,"ProcessThree",1,0],[0,"ProcessTwo",1,0],[0,"RemoveFilter",1,0],[1,"RotateAngle",0,"Expression",0],[0,"RotateAxisPoint",1,"Point",0],[0,"ScrapMethod",1,0],[0,"ScrapPosition",1,0],[0,"ScrapTol",1,0],[0,"ScrapTypeEnum",1,0],[1,"SecondScrap",0,"SelectBodyList",0],[1,"SplitCurve",0,"Section",0],[1,"SplitScrap",0,"SelectBodyList",0],[0,"TrimNum",1,0],[0,"TrimmingColor",1,0],[0,"Update",1,0],[1,"UserAddonCurve",0,"Section",0]],[[[],"GetOvercutPosition",{R_:{overcutPosition:''}},0,0],[["overcutPosition"],"SetOvercutPosition",{},1,0],[[],"ScrapDesignCreate",{},0,0],[[],"ScrapDesignEdit",{},0,0],[[],"ScrapDesignAddon",{},0,0],[[],"ScrapDesignGroup",{},0,0]],[]];
SPLM.Tooling.ScrapDesignBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ScrapDesignBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ScrapDesignBuilder.Body = Object.freeze({
    "Create" : "Create", "Edit" : "Edit", "Addon" : "Addon", "Grouping" : "Grouping"});

SPLM.Tooling.ScrapDesignBuilder.ScrapDefType = Object.freeze({
    "BlankBoundarySketch" : "BlankBoundarySketch", "HoleBoundary" : "HoleBoundary", "ClosedCurves" : "ClosedCurves", "BoundaryLines" : "BoundaryLines", "ExistedSheetBody" : "ExistedSheetBody", "ChangeType" : "ChangeType", "Copy" : "Copy"});

SPLM.Tooling.ScrapDesignBuilder.CopyMethodOptions = Object.freeze({
    "PointToPoint" : "PointToPoint", "Distance" : "Distance"});

SPLM.Tooling.ScrapDesignBuilder.DefScrapType = Object.freeze({
    "Piercing" : "Piercing", "Piloting" : "Piloting"});

SPLM.Tooling.ScrapDesignBuilder.ScrapDefPosition = Object.freeze({
    "ProjectToStrip" : "ProjectToStrip", "KeepOrigin" : "KeepOrigin"});

SPLM.Tooling.ScrapDesignBuilder.EditScrapType = Object.freeze({
    "Split" : "Split", "Merge" : "Merge", "ApplyMinimumRadius" : "ApplyMinimumRadius", "ChangeStation" : "ChangeStation", "Delete" : "Delete", "Update" : "Update"});

SPLM.Tooling.ScrapDesignBuilder.RemoveType = Object.freeze({
    "InferScrap" : "InferScrap", "Overlap" : "Overlap", "Overcut" : "Overcut", "Trimming" : "Trimming", "Hole" : "Hole", "Scrap" : "Scrap", "All" : "All"});

SPLM.Tooling.ScrapDesignBuilder.AddonType = Object.freeze({
    "Overlap" : "Overlap", "Overcut" : "Overcut", "Trimming" : "Trimming", "UserDefined" : "UserDefined"});

SPLM.Tooling.ScrapDesignBuilder.OvercutType = Object.freeze({
    "NormalType" : "NormalType", "TangentType" : "TangentType", "CircularType" : "CircularType", "RectangularType" : "RectangularType", "FilletType" : "FilletType"});

SPLM.Tooling.ScrapDesignBuilder.TrimNumType = Object.freeze({
    "One" : "One", "Two" : "Two", "Three" : "Three", "Four" : "Four", "Five" : "Five"});

export default SPLM;